/* eslint-disable react/prop-types */
import React from 'react';
import Robot from '../../shapes/Robot';
const EmptyTableRow = ({ columns, message }) => (React.createElement("tr", null,
    React.createElement("td", { colSpan: columns.length, align: 'center' },
        React.createElement(Robot, { status: 'info', size: 'sm' }),
        message)));
export { EmptyTableRow, };
